(() => {
 if (!customElements.get('tuzex-product-help')) {
  customElements.define('tuzex-product-help', class extends HTMLElement {
   openSizeRequest(size = '', variant = '', sku = '') {
    const dialog = this.querySelector('.tz-size-dialog');
    const heading = dialog.querySelector('h2');
    const intro = dialog.querySelector('[data-size-intro]');
    const input = dialog.querySelector('input[name="contact[Požadovaná veľkosť]"]');
    if (!this.sizeOriginal) this.sizeOriginal = { heading: heading.textContent, intro: intro.textContent };
    heading.textContent = size ? this.dataset.soldTitle : this.sizeOriginal.heading;
    intro.textContent = size ? this.dataset.soldIntro : this.sizeOriginal.intro;
    const selected = dialog.querySelector('[data-requested-size]');
    selected.querySelector('[data-requested-size-value]').textContent = size;
    const activeTile = this.closest('product-info')?.querySelector('tuzex-location-sizes input:checked')?.nextElementSibling;
    if (!variant) { variant = activeTile?.dataset.variantId || ''; sku = activeTile?.dataset.variantSku || ''; }
    dialog.querySelector('[data-request-sku]').textContent = sku;
    dialog.querySelector('[data-request-sku-row]').hidden = !sku;
    const skuInput = dialog.querySelector('input[name="contact[SKU]"]');
    if (skuInput) skuInput.value = sku;
    selected.hidden = !size;
    if (input) {
     input.value = size;
     input.type = size ? 'hidden' : 'text';
     const label = dialog.querySelector(`label[for="${input.id}"]`);
     label.hidden = !!size;
     label.style.display = size ? 'none' : '';
     const urlInput = dialog.querySelector('input[name="contact[Odkaz na produkt]"]');
     if (!urlInput.dataset.base) urlInput.dataset.base = urlInput.value;
     const url = new URL(urlInput.dataset.base);
     if (variant) url.searchParams.set('variant', variant);
     urlInput.value = url.href;
    }
    if (!dialog.open) dialog.showModal();
   }
   connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    for (const kind of ['price', 'size']) {
     const trigger = this.querySelector(`[data-${kind}-open]`);
     const dialog = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
     trigger.addEventListener('click', () => {
      if (kind === 'size') {
       // TUZEX v21: ak je na stránke nový dopyt pod výberom veľkosti, použijeme ten
       const root = this.closest('product-info');
       const inline = root?.querySelector('[data-tx-inquiry]');
       if (inline && root) { root.dispatchEvent(new CustomEvent('tx:size-other')); setTimeout(() => inline.scrollIntoView({ behavior: 'smooth', block: 'center' }), 60); return; }
       this.openSizeRequest();
      } else if (!dialog.open) dialog.showModal();
     });
     dialog.querySelectorAll(`[data-${kind}-close]`).forEach(button => button.addEventListener('click', () => dialog.close()));
     dialog.addEventListener('close', () => trigger.focus());
     dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
     });
     if (kind === 'size' && dialog.querySelector('[data-size-result]') &&
       (new URLSearchParams(location.search).get('size_request') === '1' || location.hash === '#' + dialog.querySelector('form')?.id)) {
      if (!dialog.open) dialog.showModal();
     }
    }
   }
  });
 }
 if (!customElements.get('tuzex-outfit-random')) {
  customElements.define('tuzex-outfit-random', class extends HTMLElement {
   connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const candidates = [...this.querySelectorAll('template[data-outfit-candidate]')];
    for (let i = candidates.length - 1; i > 0; i--) {
     const j = Math.floor(Math.random() * (i + 1));
     [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
    }
    this.replaceChildren(...candidates.slice(0, 2).map(template => template.content.cloneNode(true)));
   }
  });
 }
 if (!customElements.get('tuzex-recently-viewed')) {
  customElements.define('tuzex-recently-viewed', class extends HTMLElement {
   connectedCallback() {
    if (this.started) return;
    this.started = true;
    const key = 'tuzex-recent-session-v1';
    const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
    if (!valid(this.dataset.handle)) return;
    let history = [];
    try {
     const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
     if (Array.isArray(saved)) history = [...new Set(saved.filter(valid))];
    } catch (_) { /* Corrupt or unavailable storage must not break purchasing. */ }
    this.previous = history.filter(handle => handle !== this.dataset.handle).slice(0, 4);
    try { sessionStorage.setItem(key, JSON.stringify([this.dataset.handle, ...history.filter(handle => handle !== this.dataset.handle)].slice(0, 20))); } catch (_) {}
    if (!this.previous.length) return;
    if ('IntersectionObserver' in window) {
     this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.loadCards(); }
     }, { rootMargin: '300px' });
     this.observer.observe(this);
    } else this.loadCards();
   }
   disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.started = false; }
   async loadCards() {
    this.controller = new AbortController();
    const timer = setTimeout(() => this.controller.abort(), 10000);
    const cards = await Promise.all(this.previous.map(async handle => {
     try {
      const url = new URL(`${this.dataset.root.replace(/\/?$/, '/')}products/${encodeURIComponent(handle)}`, location.origin);
      if (url.origin !== location.origin) return null;
      url.searchParams.set('section_id', 'tuzex-recent-card');
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return doc.querySelector('template[data-recent-card]')?.content.querySelector('.tz-extra-card') || null;
     } catch (_) { return null; }
    }));
    clearTimeout(timer);
    if (!this.isConnected) return;
    const grid = this.querySelector('[data-recent-grid]');
    grid.replaceChildren(...cards.filter(Boolean));
    this.querySelector('[data-recent-content]').hidden = !grid.children.length;
   }
  });
 }
})();
